import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NowcastDataService {

  urlConst: any = environment.url.HEATWAVE_STAGING_API_URL

  constructor(private http: HttpClient, private datePipe: DatePipe, private utils: UtilsService) { }


  getNowcastData(postData): Observable<any> {
    return this.http.post(this.urlConst + "nowcast/getTableData", postData)
  }

  getHeirarchy(postData) {
    let url = this.urlConst + "locations/heirarchy";
    return this.http.post<any>(url, postData)
  }

  getNowcastChartData(postData): Observable<any> {
    return this.http.post(this.urlConst + "nowcast/getChartData", postData)
  }

  getHeatMapData(source) {
    let url = this.urlConst + 'nowcast/getHeatMapData/NOWCAST/' + source;
    return this.http.get<any>(url);
  }
  getCityalertData(postData) {
    return this.http.post(this.urlConst + "nowcast/getNowcastAlertData", postData)
  }
  nowcastAlertData(postData) {
    return this.http.post(this.urlConst + "nowcast/getRainfallNowcastAlertData", postData)
  }

  getNowcastAlertCounts(postData): Observable<any> {
    return this.http.post(this.urlConst + "nowcast/alertCounts", postData);
  }

  getRadarStations(): Observable<any> {
    return this.http.get(this.urlConst + 'nowcast/getRadarStatus');
  }

  getLatestProcessedTS() {
    return this.http.get("http://192.168.16.160:9000/api/nowcast/getLatestProcessedFileNameOfNowcastSources")
  }


  deepClone(object: any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj: any = {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  getChartData(formattedChartData: any[], params: any): any {
    // let locType = params['locType'] !== 'STATE' ? 'Districts' : 'Blocks';
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let currentLevel: any = hie[hie.indexOf(params.locType) - 1];
    let firstLevel: any = hie[hie.indexOf(params.locType) + 1];
    let locType
    if (params.view == 'Admin') {
      // locType = firstLevel.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      locType = this.utils.titleCase(firstLevel) + 's';

    } else if (params.view == 'City') {
      if (params.pUUID == 'd49a7f7d-3437-42a5-999c-e62c8878f1a3') {
        locType = 'Wards'
      } else {
        locType = params.locType == 'COUNTRY' ? 'Cities' : 'Blocks'
      }
    }

    if (!formattedChartData || formattedChartData.length === 0) {
      return {}; // return empty if no data
    }

    // Extract timestamps (keys except "Rainfall Band")
    const timestamps = Object.keys(formattedChartData[0]).filter(key => key !== "Rainfall Band");

    // Format timestamps to readable time like "08:30"
    const categories = timestamps.map(ts => {
      const date = new Date(Number(ts));
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      const hours12 = hours % 12 || 12;
      return `${hours12}:${minutes} ${ampm}`;
    });

    const colorMap: { [key: string]: string } = {
      "No Rain": "#ffffff",
      "Very Light": "#E6EEFF",
      "Light": "#80AAFF",
      "Moderate": "#3377FF",
      "Heavy": "#002266",
      "Very Heavy": "#FF80B3",
      "Extreme": "#CC0000",
      "Cloud Burst": "#660000"
    };    // Dynamically generate series for each Rainfall Band
    const series = formattedChartData.map(item => ({
      name: item["Rainfall Band"],
      type: 'column',
      data: timestamps.map(ts => item[ts] || 0),
      color: colorMap[item["Rainfall Band"]] || "#808080" // default color if not found
    }));

    const chartOptions = {
      chart: {
        type: 'column',
        backgroundColor: '#000000'
      },
      title: {
        text: '',
        style: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
        }
      },
      xAxis: {
        categories: categories,
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `No of ${locType}`,
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        gridLineColor: '#808080'
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemMarginTop: 4,
        itemMarginBottom: 4,
        symbolRadius: 0,
        itemStyle: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
          fontSize: '10px',
          fontWeight: 'normal'
        }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true
          },
          borderWidth: 0.1,
          borderColor: '#000'
        }
      },
      series: series,
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      }
    };

    return chartOptions;
  }

  getChartDataForLandingPage(formattedChartData: any[]): any {
    if (!formattedChartData || formattedChartData.length === 0) {
      return {};
    }
    const timestamps = Object.keys(formattedChartData[0]).filter(key => key !== "Rainfall Band");
    const categories = timestamps.map(ts => {
      const date = new Date(Number(ts));
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    });
    const colorMap: { [key: string]: string } = {
      "no rainfall": "#ffffff",
      "very light rainfall": "#C3FDCA",
      "light rainfall": "#00FE08",
      "moderate rainfall": "#038500",
      "heavy rainfall": "#FDBFC9",
      "very heavy rainfall": "#FC0300",
      "extremely heavy rainfall": "#610301"
    };
    const series = formattedChartData.map(item => ({
      name: item["Rainfall Band"],
      type: 'column',
      data: timestamps.map(ts => item[ts] || 0),
      color: colorMap[item["Rainfall Band"]] || "#808080"
    }));

    const chartOptions = {
      chart: {
        type: 'column',
        height: 280,
        backgroundColor: '#404040'
      },
      title: {
        text: '',
        style: { color: '#ffffff' }
      },
      xAxis: {
        categories: categories,
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `No of States`,
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        labels: {
          style: {
            color: '#9aa2a7ff',
            fontFamily: 'poppins, sans-serif',
          }
        },
        gridLineColor: '#808080'
      },
      legend: {

        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemMarginTop: 2,
        itemMarginBottom: 2,
        symbolRadius: 0,
        itemStyle: {
          color: '#9aa2a7ff',
          fontFamily: 'poppins, sans-serif',
          fontSize: '8px',
          fontWeight: 'normal'
        },
        title: {
          text: '',
          style: { color: '#ffffff', fontWeight: 'bold' }
        }
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          // dataLabels: {
          //   enabled: true
          // }
        }
      },
      series: series,
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      }
    };

    return chartOptions;
  }

  setChartData(data, ProjConstants) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj = {};
      for (const item of Object.keys(data[key])) {

        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['RAINFALL']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  formatDateString(timestamp: number): string {
    // console.log(timestamp, "timestamp");
    let date = new Date(timestamp);
    return this.datePipe.transform(date, 'dd-MMM-yyyy hh:mm a', '+0530');
  }

  getNext5HrsTimeStampsWithHeatMaps(response, source) {
    if (response) {
      const blocks = {};
      let keysList = Object.keys(response);
      for (let i = 0; i < keysList.length; i++) {
        blocks[i] = {};
        blocks[i]['timeStamp'] = keysList[i];
        blocks[i]['timeLineName'] = {};
        blocks[i]['timeLineName']['toolTip'] = this.convertNowcastTimestampToFullBlockValueForNowcast(blocks[i]['timeStamp'], source);
        blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
        blocks[i]['timeLinePos'] = i;
        blocks[i]['url'] = response[keysList[i]]['heatMapImage'];
        blocks[i]['heatMapImageBound'] = response[keysList[i]]['heatMapImageBound'];
      }
      return blocks;
    }

  }

  convertNowcastTimestampToFullBlockValueForNowcast(ts, source) {
    if (source == 'RICKEN') {
      ts = Number(ts);
      let starthours = new Date(ts).getHours();
      const startminutes = new Date(ts).getMinutes();
      let startAmPm = 'A.M';
      if (starthours == 12) {
        starthours = starthours;
        startAmPm = 'P.M';
      }
      if (starthours > 12) {
        starthours = starthours - 12;
        startAmPm = 'P.M';
      }
      let endhours = new Date(ts + ProjConstants.MILLIS_IN_1HOUR).getHours();
      const endminutes = new Date(ts + ProjConstants.MILLIS_IN_1HOUR).getMinutes();
      let endamPm = 'A.M';
      if (endhours == 12) {
        endhours = endhours;
        endamPm = 'P.M';
      }
      if (endhours > 12) {
        endhours = endhours - 12;
        endamPm = 'P.M';
      }
      return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
    } else if (source == 'IMD RADAR') {
      ts = Number(ts);
      let starthours = new Date(ts).getHours();
      const startminutes = new Date(ts).getMinutes();
      let startAmPm = 'A.M';
      if (starthours == 12) {
        starthours = starthours;
        startAmPm = 'P.M';
      }
      if (starthours > 12) {
        starthours = starthours - 12;
        startAmPm = 'P.M';
      }
      let endhours = new Date(ts + 10 * 60 * 1000).getHours();
      let endminutes = new Date(ts + 10 * 60 * 1000).getMinutes();
      const endMinutesString = endminutes < 10 ? '0' + endminutes : endminutes.toString();
      let endamPm = 'A.M';
      if (endhours == 12) {
        endhours = endhours;
        endamPm = 'P.M';
      }
      if (endhours > 12) {
        endhours = endhours - 12;
        endamPm = 'P.M';
      }
      // return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + endMinutesString.toString() + ' ' + endamPm;
      return starthours.toString() + ':' + (startminutes < 10 ? '0' + startminutes : startminutes.toString()) + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + (endminutes < 10 ? '0' + endminutes : endminutes.toString()) + ' ' + endamPm;
    } else if (source == 'RADAR') {
      ts = Number(ts);
      let starthours = new Date(ts).getHours();
      const startminutes = new Date(ts).getMinutes();
      let startAmPm = 'A.M';
      if (starthours == 12) {
        starthours = starthours;
        startAmPm = 'P.M';
      }
      if (starthours > 12) {
        starthours = starthours - 12;
        startAmPm = 'P.M';
      }
      let endhours = new Date(ts + 10 * 60 * 1000).getHours();
      let endminutes = new Date(ts + 10 * 60 * 1000).getMinutes();
      const endMinutesString = endminutes < 10 ? '0' + endminutes : endminutes.toString();
      let endamPm = 'A.M';
      if (endhours == 12) {
        endhours = endhours;
        endamPm = 'P.M';
      }
      if (endhours > 12) {
        endhours = endhours - 12;
        endamPm = 'P.M';
      }
      // return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + endMinutesString.toString() + ' ' + endamPm;
      return starthours.toString() + ':' + (startminutes < 10 ? '0' + startminutes : startminutes.toString()) + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + (endminutes < 10 ? '0' + endminutes : endminutes.toString()) + ' ' + endamPm;
    } else if (source == 'RADAR+CTT') {
      ts = Number(ts);
      let starthours = new Date(ts).getHours();
      const startminutes = new Date(ts).getMinutes();
      let startAmPm = 'A.M';
      if (starthours == 12) {
        starthours = starthours;
        startAmPm = 'P.M';
      }
      if (starthours > 12) {
        starthours = starthours - 12;
        startAmPm = 'P.M';
      }
      let endhours = new Date(ts + 10 * 60 * 1000).getHours();
      let endminutes = new Date(ts + 10 * 60 * 1000).getMinutes();
      const endMinutesString = endminutes < 10 ? '0' + endminutes : endminutes.toString();
      let endamPm = 'A.M';
      if (endhours == 12) {
        endhours = endhours;
        endamPm = 'P.M';
      }
      if (endhours > 12) {
        endhours = endhours - 12;
        endamPm = 'P.M';
      }
      // return starthours.toString() + ':' + startminutes.toString() + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + endMinutesString.toString() + ' ' + endamPm;
      return starthours.toString() + ':' + (startminutes < 10 ? '0' + startminutes : startminutes.toString()) + ' ' + startAmPm + ' - ' + endhours.toString() + ':' + (endminutes < 10 ? '0' + endminutes : endminutes.toString()) + ' ' + endamPm;
    }
  }

  convertTimestampToBlockValue(ts: number): any {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours == 12) {
      hours = 12;
      amPm = 'P.M';
    }
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString().padStart(2, '0') + ' ' + amPm;
  }

  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = []

    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  convertToDateTime(input: string) {
    const year = parseInt(input.slice(0, 4));
    const month = parseInt(input.slice(4, 6)) - 1;
    const day = parseInt(input.slice(6, 8));
    const hour = parseInt(input.slice(8, 10));
    const minute = parseInt(input.slice(10, 12));

    const date = new Date(year, month, day, hour, minute)
    // Parse as UTC
    const utcDate = new Date(Date.UTC(year, month, day, hour, minute));
    // Add 5h 30m (19800000 ms)
    const istDate = new Date(utcDate.getTime() + (5 * 60 * 60 * 1000) + (30 * 60 * 1000));

    const formatted = istDate.toISOString().replace('T', ' ').substring(0, 19);
    return {
      millis: istDate.getTime(),
      formatted: formatted,
    };
  }
  setRainfallcolor(value1) {
    let value: string = value1;
    value = value.toString().replace(",", "");
    let obj;
    if (value == 'no rainfall' || value == '-') {
      obj = { 'textcolor': '#000000', 'bgcolor': '#ffffff', 'col': 'color1' }
    }
    else if (value == 'very light rainfall') {
      obj = { 'textcolor': '#000000', 'bgcolor': '#E6EEFF', 'col': 'color2' }
    }
    else if (value == 'light rainfall') {
      obj = { 'textcolor': '#000000', 'bgcolor': '#80AAFF', 'col': 'color3' }
    }
    else if (value == 'moderate rainfall') {
      obj = { 'textcolor': '#000000', 'bgcolor': '#3377FF', 'col': 'color4' }
    }
    else if (value == 'heavy rainfall') {
      obj = { 'textcolor': '#ffffff', 'bgcolor': '#002266', 'col': 'color5' }
    }
    else if (value == 'very heavy rainfall') {
      obj = { 'textcolor': '#ffffff', 'bgcolor': '#FF80B3', 'col': 'color6' }
    }
    else if (value == 'extreme rainfall') {
      obj = { 'textcolor': '#ffffff', 'bgcolor': '#CC0000', 'col': 'color7' }
    }
    else {
      obj = { 'textcolor': '#ffffff', 'bgcolor': '#660000', 'col': 'color1' }
    }
    return obj;
  }

  alertCategoryColorMapping = {
    'no rain': '#d3d8dc',
    'light rain': '#004aff',
    'moderate rain': '#fffd4f',
    'heavy rain': '#ff0000',
    'very heavy rain': '#943131'
  }

  getDateFormatFromTS(millis) {
    const date = new Date(millis);

    // Pad helper function
    const pad = (n: number) => n.toString().padStart(2, '0');

    const formatted =
      date.getFullYear().toString() +
      pad(date.getMonth() + 1) +
      pad(date.getDate()) +
      pad(date.getHours()) +
      pad(date.getMinutes());

    return formatted
  }

  formatDate(dateStr: string): string {
    const match = dateStr.match(
      /^(\d{2})([A-Za-z]{3})(\d{4})_(\d{2})(\d{2})$/
    );
    if (!match) {
      return dateStr;
    }
    const [, day, month, year, hour, minute] = match;
    return `${day} ${month} ${year} ${hour}:${minute}`;
  }

}
